import React from 'react'

const StepperItem = ( { label, active, edge, onPress } ) => {
    return (
      <div onClick={onPress} className={`${active ? `bg-[#4D4D4D] text-white rounded-t-md` : `text-black bg-white`} text-sm uppercase px-4 py-2 cursor-pointer ${ edge ? `mx-0`: `mx-2`}`}>
        {label}
      </div>
    )
}

export default StepperItem